/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum DeviceStatus {
    Created = '0',
    Registered = 1,
    Deleted = 2,
    Inactive = 3,
}
